import Route from '@ember/routing/route';
import type Controller from '@ember/controller';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import { service } from '@ember/service';
import type EmployeeModel from 'tio-data/models/employee';
import type PersonModel from 'tio-data/models/person';
import type SessionContextService from 'tio-employee/services/session-context';

export default class ProfileRoute extends Route {
  @service declare store: StoreService;
  @service sessionContext!: SessionContextService;

  resetController(controller: Controller, isExiting: boolean) {
    if (isExiting) {
      controller.set('parentDashboard', undefined);
    }
  }

  async model() {
    if (this.sessionContext.isFamilyMember) {
      const personId = this.sessionContext.person?.id;

      if (!personId) {
        throw new Error('Person ID is missing');
      }

      const familyPerson = await this.store.findRecord<PersonModel>('person', personId, {
        reload: true,
        include: ['phone-numbers', 'user.logins'],
      });

      return { familyPerson };
    }

    const employeeId = this.sessionContext.currentEmployee.id || '';
    const employee = await this.store.findRecord<EmployeeModel>('employee', employeeId, {
      reload: true,
      include: [
        'phone-numbers',
        'person.user.logins',
        'dependents.person.user.logins',
        'company.company-setting',
      ],
    });

    return { employee };
  }
}
